<template>
  <component
    :class="getClass"
    :data-target="getDataTarget"
    :data-toggle="getDataToggle"
    :disabled="disabled"
    :exact="exact"
    :href="href"
    :is="getTag"
    :target="target"
    :to="to"
    :type="getType"
    @click="click">
    <template v-if="hasBaseIconLeft()">
      <base-icon :icon="iconLeft" :class="{ 'mr-2': hasText() }"/>
    </template>
    <slot/>
    <template v-if="text">
      {{ text }}
    </template>
    <template v-if="hasBaseIconRight() && !loading">
      <base-icon :icon="iconRight" :class="{ 'ml-2': hasText() }"/>
    </template>
    <template v-if="loading">
      <base-icon icon="spinner" spin :class="{ 'ml-2': hasText() }"/>
    </template>
  </component>
</template>

<script>
export default {
  data () {
    return {
      defaultVariant: 'light'
    }
  },

  name: 'BaseButton',

  props: {
    active: Boolean,
    block: Boolean,
    blue: Boolean,
    collapse: String,
    danger: Boolean,
    dark: Boolean,
    disabled: Boolean,
    dropdown: Boolean,
    exact: Boolean,
    href: String,
    green: Boolean,
    iconLeft: String,
    iconRight: String,
    info: Boolean,
    large: Boolean,
    light: Boolean,
    link: Boolean,
    loading: Boolean,
    modal: String,
    noToggle: Boolean,
    preventDefault: Boolean,
    primary: Boolean,
    ripple: Boolean,
    secondary: Boolean,
    small: Boolean,
    submit: Boolean,
    success: Boolean,
    target: String,
    text: String,
    to: Object,
    warning: Boolean
  },

  computed: {
    getClass () {
      const classes = ['btn']
      const convertions = {
        blue: 'primary',
        large: 'lg',
        green: 'success',
        red: 'danger',
        small: 'sm',
        yellow: 'warning'
      }
      const variants = [
        'block',
        'danger',
        'dark',
        'light',
        'link',
        'primary',
        'ripple',
        'secondary',
        'success',
        'warning'
      ]
      const push = (variant) => {
        classes.push(`btn-${variant}`)

        if (!['block', 'lg', 'sm'].includes(variant)) hasColour = true
      }
      let hasColour = false

      this.$_.forIn(convertions, (variant, prop) => {
        if (this[prop]) {
          push(variant)
        }
      })
      variants.forEach(variant => {
        if (this[variant]) {
          push(variant)
        }
      })

      if (!hasColour) push(this.defaultVariant)

      if (this.active) classes.push('active')

      if (this.dropdown) {
        classes.push('dropdown-toggle')
      }

      return this.$_.uniq(classes).join(' ')
    },

    getDataTarget () {
      if (this.collapse) {
        return this.collapse
      }

      if (this.modal) {
        return this.modal
      }
    },

    getDataToggle () {
      if (this.noToggle) return false

      if (this.collapse) {
        return 'collapse'
      }

      if (this.dropdown) {
        return 'dropdown'
      }

      if (this.modal) {
        return 'modal'
      }
    },

    getTag () {
      if (this.href) return 'a'

      return this.$_.isPlainObject(this.to) ? 'router-link' : 'button'
    },

    getType () {
      if (this.getTag !== 'button') return null

      return this.submit === true ? 'submit' : 'button'
    }
  },

  methods: {
    click ($event) {
      if (this.preventDefault) {
        $event.preventDefault()
      }

      this.$emit('click')
    },

    hasBaseIconLeft () {
      return this.$_.isString(this.iconLeft) && this.iconLeft !== ''
    },

    hasBaseIconRight () {
      return this.$_.isString(this.iconRight) && this.iconRight !== ''
    },

    hasText () {
      return this.$_.has(this.$slots, 'default') || this.text
    }
  }
}
</script>
